import { render, staticRenderFns } from "./ItemsPerTableDropdown.vue?vue&type=template&id=79a3ffa3&"
import script from "./ItemsPerTableDropdown.vue?vue&type=script&lang=js&"
export * from "./ItemsPerTableDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ItemsPerTableDropdown.vue?vue&type=style&index=0&id=79a3ffa3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports